/**
* @prop --uic-menu-bg-color: default background color
* @prop --uic-menu-bg-color-secondary: background color for variant `secondary`
* @prop --uic-menu-text-color: default text and icon color
*/
.uic-menu {
  background-color: var(--uic-menu-bg-color);
  color: var(--uic-menu-text-color);
  display: block;
  position: relative;

  .uic-menu__inner {
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    position: relative;
  }

  &--vertical {
    .uic-menu__inner {
      align-items: stretch;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
  }

  &--secondary {
    background-color: var(--uic-menu-bg-color-secondary);
  }
}
